import { graphql } from 'relay-runtime';

export const ATLASSIAN_ACCOUNT_USER_QUERY = graphql`
  query AtlassianAccountUserQuery {
    me {
      user {
        accountId
        accountStatus
        name
        ... on AtlassianAccountUser {
          email
          nickname
          picture
          ...AtlassianAccountUserFragment
        }
      }
    }
  }
`;
